import { gql } from 'graphql-tag';

import { GetInstructorLedTrainingQuery } from 'src/graphql/generated/GetInstructorLedTraining';
import {
  AT_IMAGE_FRAGMENT,
  OR_VIDEO_FRAGMENT,
  ML_LAYOUT_CONTENT_FRAGMENT,
  ILT_FAQ_ITEM_FRAGMENT,
  ILT_FAQ_SECTION_FRAGMENT,
  ENTRY_LAYOUT_FRAGMENT,
} from 'src/graphql/fragments/fragments';

export const GET_INSTRUCTOR_LED_TRAINING = gql`
  ${AT_IMAGE_FRAGMENT}
  ${OR_VIDEO_FRAGMENT}
  ${ENTRY_LAYOUT_FRAGMENT}
  ${ML_LAYOUT_CONTENT_FRAGMENT}
  ${ILT_FAQ_ITEM_FRAGMENT}
  ${ILT_FAQ_SECTION_FRAGMENT}
  query getInstructorLedTraining($slug: String!, $preview: Boolean!) {
    instructorLedTrainingCollection(preview: $preview, limit: 1, where: { slug: $slug }) {
      items {
        __typename
        sys {
          id
        }
        courseTitleExternal
        duration
        free
        description {
          json
          links {
            assets {
              block {
                sys {
                  id
                }
                title
                description
                fileName
                url
                width
                height
                contentType
              }
              hyperlink {
                sys {
                  id
                }
                title
                description
                fileName
                url
              }
            }
            entries {
              block {
                __typename
                sys {
                  id
                }
                ... on AtImage {
                  ...AtImageFragment
                }
                ... on OrVideo {
                  ...OrVideoFragment
                }
              }
              inline {
                __typename
                sys {
                  id
                }
                ... on AtImage {
                  ...AtImageFragment
                }
              }
            }
          }
        }
        instructor {
          sys {
            id
          }
          nameInternal
          image {
            ...AtImageFragment
          }
          imageAlt
          bio
          contactEmail
          locationValue
        }
        partnersCollection {
          items {
            sys {
              id
            }
            title
            email
            website
            shortDescription
            regions
            image {
              url
              title
              description
            }
          }
        }
        faqSection {
          ...IltFaqSectionFragment
        }
        studentMaterialsCollection {
          items {
            __typename
            ... on Document {
              sys {
                id
              }
              nameExternal
              nameInternal
              description
              studentUrl
              instructorUrl
            }
            ... on OrVideo {
              ...OrVideoFragment
            }
          }
        }
        instructorMaterialsCollection {
          items {
            __typename
            ... on Document {
              sys {
                id
              }
              nameExternal
              nameInternal
              description
              studentUrl
              instructorUrl
            }
            ... on OrVideo {
              ...OrVideoFragment
            }
          }
        }
      }
    }
  }
`;

export type ContentfulInstructorLedTrainingResponse = GetInstructorLedTrainingQuery;
export type ContentfulInstructorLedTraining =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0];
export type ContentfulInstructorLedTrainingDescription =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['description'];
export type ContentfulInstructor =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['instructor'];
export type ContentfulPartner =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['partnersCollection']['items'][0];
export type ContentfulIltFaqSection =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['faqSection'];
export type ContentfulIltFaqItem = NonNullable<
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['faqSection']
>['faqItemsCollection']['items'][0];
export type ContentfulStudentMaterial =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['studentMaterialsCollection']['items'][0];
export type ContentfulInstructorMaterial =
  GetInstructorLedTrainingQuery['instructorLedTrainingCollection']['items'][0]['instructorMaterialsCollection']['items'][0];
